import React from 'react';
import * as PropTypes from "prop-types";
import {Link} from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import {withStyles} from '@material-ui/core/styles';
import indigo from "@material-ui/core/colors/indigo";
import Utility from "../Utility";

const styles = () => ({
    screenName: {
        textAlign: 'left',
        color: 'white',
        backgroundColor: indigo[300],
        minHeight: 'inherit',
    },
});

function createLogoutButton() {
    const ButtonLink = props => <Link to={{pathname: 'logout'}} {...props} />;
    return (
        <Tooltip title="ログアウト">
            <IconButton
                color="inherit"
                component={ButtonLink}
                style={{position: 'absolute', top: 0, right: 0}}
                aria-label="logout"
            >
                <ExitToAppIcon fontSize="large"/>
            </IconButton>
        </Tooltip>
    )
}

export class HeaderBar extends React.Component {
    constructor(props) {
        super(props);

        this.isLogin = this.isLogin.bind(this);
    }

    isLogin() {
        let id = this.props.cookies.get('id');
        let role = this.props.cookies.get('role');
        let token = this.props.cookies.get('token');
        return !(Utility.isNullOrUndefined(id) || Utility.isNullOrUndefined(role) || Utility.isNullOrUndefined(token));
    }

    render() {
        return (
            <AppBar position="static">
                <Toolbar>
                    <Typography color="inherit" align="center">{this.props.serviceName}</Typography>
                    {
                        // ログイン済みであればログアウトボタンを表示する.
                        this.isLogin() && createLogoutButton()
                    }
                </Toolbar>
                <Toolbar position="static" className={this.props.classes.screenName}>{this.props.screenName}</Toolbar>
            </AppBar>
        );
    }
}

HeaderBar.propTypes = {
    cookies: PropTypes.object.isRequired,
    serviceName: PropTypes.string.isRequired,
    screenName: PropTypes.string.isRequired,
};

export default withStyles(styles)(HeaderBar);
